export function getAnalyticsId() {
  return process.env.REACT_APP_ANALYTICS_ID
}

export function getDisclaimer() {
  return window.env.REACT_APP_DISCLAIMER
}

export function getApiUrl() {
  return window.env.REACT_APP_API_URL
}